import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, post } from "@insite/client-framework/Services/ApiService";

const wishListUrl = "/api/v1/wishlists";

export interface WishListLineCollectionModel {
    erpNumber: string;
    productId: string;
    qtyOrdered: number;
    shortDescription: string;
}

export interface AddWishListLinesApiParameter extends ApiParameter {
    wishListId: string;
    wishListLines: WishListLineCollectionModel;
}

export async function undoWishListLine(
    parameter: AddWishListLinesApiParameter,
): Promise<ServiceResult<WishListLineCollectionModel>> {
    try {
        const wishlistlines = await post<WishListLineCollectionModel>(
            `${wishListUrl}/${parameter.wishListId}/wishlistlines/batch/${parameter.wishListId}`,
            parameter as any,
        );
        return {
            result: wishlistlines,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
